
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Blocca',
	'find_label': 'Trova',
	'findCancelLabel': 'Annulla',
	'dataPaneLabel': 'Dati',
	'sourcePaneLabel': 'Seleziona origini',
	'sourcePaneContentLabel': 'Seleziona un\'origine',
	'emptySourcePaneTitle': 'Seleziona un\'origine',
	'emptySourcePaneCaption': 'Fare clic per selezionare un sorgente per aggiungere i dati da utilizzare per costruire un dashboard.',
	'addDataSource': 'Seleziona un\'origine',
	'addDataDashboardCoachMarkContents': 'Trascinare e rilasciare i dati dal pannello di dati al proprio dashboard.',
	'addDataStoryCoachMarkContents': 'Trascinare e rilasciare i dati dal pannello di dati nella proprio storia.',
	'addDataCoachMarkTitle': 'Aggiungi dati',
	'selectSourcesText': 'Selezionare ed aggiungere un\'origine dati per costruire il proprio %{app}.',
	'selectSourcesLabel': 'Seleziona un\'origine',
	'errorSourcesTitle': 'Impossibile caricare la struttura dei dati',
	'errorLoadingDataSources': 'Si è verificato un errore durante il caricamento dell\'elenco di dataset.',
	'errorLoadingDataTree': 'Si è verificato un errore durante il caricamento della struttura ad albero',
	'dataSetPaneLastUpdated': 'Ultimo aggiornamento: %{date}',
	'dataSourcePaneDateUnknown': 'Sconosciuto',
	'moreTitle': 'Altro',
	'backLabel': 'Torna indietro',
	'addDataSourceDialogTitle': 'Seleziona un\'origine',
	'addDataSourceDialogButtonLabel': 'Aggiungi',
	'dlg_use': 'Utilizza',
	'dlg_RelinkDataSourceTitle': 'Sostituire il dataset "%{dataSourceName}" con ...',
	'propertiesDialogTitle': 'Proprietà',
	'loadingMetadata': 'Caricamento metadati',
	'missingDataSetData': 'I dati per questo dataset non sono disponibili. Aggiornare il dataset o rivolgersi all\'amministratore per accedere all\'origine.',
	'errorLoadingSource': 'I metadati per "%{sourceName}" non sono stati caricati. Contattare l\'amministratore per i dettagli.',
	'errorMessageTitle': 'Errore',
	'calculation_navigation_in_use': 'L\'eliminazione dei calcoli, dei filtri o dei percorsi di navigazione invalida tutte le visualizzazioni che fanno riferimento all\'elemento eliminato. Si è sicuri di voler eliminare?',
	'delete_confirm': 'Conferma eliminazione',
	'previewUnavailable': 'Il livello dati ed i filtri globali non sono disponibili per questo tipo di package.',
	'contextualGridTabName': 'Dati della visualizzazione',
	'DATA_TRAY_no_data_text': 'Al momento non hai alcun dato',
	'contextualGridMenuLabel': 'Menu dati di visualizzazione',
	'contextualGridExport': 'Esporta',
	'nullValueText': 'Nullo',
	'forecastDetailsTabName': 'Previsione dettagli statistici',
	'forecastDetailsModelLabel': 'Modello',
	'forecastDetailsQualityMetricLabel': 'Misure di accuratezza',
	'forecastDetailsSmoothingCoefLabel': 'Parametri',
	'forecastDetailsDiagnostics': 'Diagnostica',
	'forecastDetailsForecastLabel': 'Previsione',
	'forecastDetailsStatusLabel': 'Stato',
	'forecastDetailsAccuracyPercentLabel': 'Precisione (%)',
	'forecastDetailsTrendLabel': 'Tendenza',
	'forecastDetailsSeasonLabel': 'Stagionalità',
	'forecastDetailsSeasonalPeriodLabel': 'Periodo stagionale',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Conto mancante',
	'forecastDetailsSeriesLengthLabel': 'Lunghezza della serie',
	'forecastDetailsIgnoredPeriods': 'Periodi ignorati',
	'forecastDetailsTrendStrength': 'Forza del trend',
	'forecastDetailsSeasonalityStrength': 'Forza della stagionalità',
	'forecastDetailsTimeDeltaUnit': 'Intervallo di data / ora',
	'forecastDetailsNotes': 'Note'
});
